module.exports = __webpack_public_path__ + "img/buy_disable.9bade104.png";